import React, { useState } from "react";
import { Form, InputGroup, Button } from "react-bootstrap";
import { useSyncedField } from "../../components/Sidebar";

// parameters.auth shape: { type, bearer_token?, client_key?, secret_key? }

const AUTH_TYPES = [
    { value: "NONE", label: "None" },
    { value: "BEARER", label: "Bearer Token" },
    { value: "OAUTH_CLIENT_CREDENTIALS", label: "OAuth Client Credentials" },
];

const WebhookAuth = () => {
    const [parameters, setParameters] = useSyncedField("parameters", {});
    const [showToken, setShowToken] = useState(false);
    const [showSecret, setShowSecret] = useState(false);

    const auth = parameters?.auth ?? { type: "NONE" };

    const updateAuth = (patch) =>
        setParameters({ ...parameters, auth: { ...auth, ...patch } });

    return (
        <div className="p-3">
            <Form>
                <Form.Group className="mb-4">
                    <Form.Label>Authentication Type</Form.Label>
                    <Form.Select
                        value={auth.type ?? "NONE"}
                        onChange={(e) => updateAuth({ type: e.target.value })}
                    >
                        {AUTH_TYPES.map((t) => (
                            <option key={t.value} value={t.value}>
                                {t.label}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                {auth.type === "BEARER" && (
                    <Form.Group className="mb-3">
                        <Form.Label>Bearer Token</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showToken ? "text" : "password"}
                                value={auth.bearer_token ?? ""}
                                onChange={(e) => updateAuth({ bearer_token: e.target.value })}
                                placeholder="Enter token"
                            />
                            <Button
                                variant="outline-secondary"
                                onClick={() => setShowToken((v) => !v)}
                                tabIndex={-1}
                            >
                                <i className={`fa fa-eye${showToken ? "-slash" : ""}`} />
                            </Button>
                        </InputGroup>
                    </Form.Group>
                )}

                {auth.type === "OAUTH_CLIENT_CREDENTIALS" && (
                    <>
                        <Form.Group className="mb-3">
                            <Form.Label>Client Key / ID</Form.Label>
                            <Form.Control
                                value={auth.client_key ?? ""}
                                onChange={(e) => updateAuth({ client_key: e.target.value })}
                                placeholder="Client key or ID"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Client Secret</Form.Label>
                            <InputGroup>
                                <Form.Control
                                    type={showSecret ? "text" : "password"}
                                    value={auth.secret_key ?? ""}
                                    onChange={(e) => updateAuth({ secret_key: e.target.value })}
                                    placeholder="Client secret"
                                />
                                <Button
                                    variant="outline-secondary"
                                    onClick={() => setShowSecret((v) => !v)}
                                    tabIndex={-1}
                                >
                                    <i className={`fa fa-eye${showSecret ? "-slash" : ""}`} />
                                </Button>
                            </InputGroup>
                            <Form.Text className="text-muted">
                                Credentials are sent as HTTP Basic auth (Base64 encoded).
                            </Form.Text>
                        </Form.Group>
                    </>
                )}

                {(auth.type === "NONE" || !auth.type) && (
                    <p className="text-muted small">
                        No authentication will be added to the request.
                    </p>
                )}
            </Form>
        </div>
    );
};

export default WebhookAuth;
